import React from "react";
import { Link } from "react-router-dom";

import swimmingPoolImage from "../assets/images/swimming-pool-design.png";
import ModernPoolDesign from "../assets/images/Modern-Pool-Design.png";
import VillaSwimmingPool from "../assets/images/Villa-Swimming-Pool.jpeg";
import LuxuryPoolDesign from "../assets/images/Luxury-Pool-Design.jpg";

const SwimmingPoolDesign = () => {
  const poolServices = [
    {
      id: 1,
      icon: "fas fa-swimming-pool",
      title: "Residential Swimming Pool Design",
      description:
        "Beautiful and practical swimming pool designs created for villas, homes, gardens, and private outdoor spaces.",
    },
    {
      id: 2,
      icon: "fas fa-home",
      title: "Villa Swimming Pool Design",
      description:
        "Custom pool designs that complement your villa architecture, garden layout, and overall outdoor environment.",
    },
    {
      id: 3,
      icon: "fas fa-star",
      title: "Luxury Swimming Pool Design",
      description:
        "Elegant and premium swimming pool concepts designed to create a sophisticated outdoor lifestyle experience.",
    },
    {
      id: 4,
      icon: "fas fa-water",
      title: "Modern Pool Design",
      description:
        "Contemporary swimming pool designs with clean lines, modern layouts, attractive finishes, and functional features.",
    },
    {
      id: 5,
      icon: "fas fa-tree",
      title: "Garden Swimming Pool Design",
      description:
        "Pool designs integrated with gardens, plants, landscaping, seating areas, and surrounding outdoor features.",
    },
    {
      id: 6,
      icon: "fas fa-pencil-ruler",
      title: "Custom Pool Design",
      description:
        "Fully customized swimming pool concepts planned according to your available space, requirements, and preferences.",
    },
  ];

  const poolFeatures = [
    {
      id: 1,
      icon: "fas fa-drafting-compass",
      title: "Pool Layout & Shape",
      description:
        "Carefully planned pool layouts and shapes that make the best use of your available outdoor space.",
    },
    {
      id: 2,
      icon: "fas fa-lightbulb",
      title: "Pool Lighting",
      description:
        "Attractive lighting concepts that enhance the appearance, atmosphere, and usability of your swimming pool.",
    },
    {
      id: 3,
      icon: "fas fa-water",
      title: "Water Features",
      description:
        "Add visual appeal with professionally planned water features, waterfalls, fountains, and decorative elements.",
    },
    {
      id: 4,
      icon: "fas fa-th-large",
      title: "Pool Decking",
      description:
        "Suitable poolside decking concepts designed for comfort, appearance, functionality, and outdoor use.",
    },
    {
      id: 5,
      icon: "fas fa-leaf",
      title: "Pool Landscaping",
      description:
        "Swimming pools integrated with greenery, planting, garden features, and surrounding landscape design.",
    },
    {
      id: 6,
      icon: "fas fa-couch",
      title: "Outdoor Pool Areas",
      description:
        "Complete outdoor concepts including poolside seating, relaxation areas, pathways, and surrounding spaces.",
    },
  ];

  const designProcess = [
    {
      id: 1,
      number: "01",
      title: "Consultation",
      description:
        "We discuss your requirements, preferences, lifestyle needs, and ideas for your swimming pool project.",
    },
    {
      id: 2,
      number: "02",
      title: "Site Assessment",
      description:
        "We review the available outdoor space, existing landscape, access, layout, and project requirements.",
    },
    {
      id: 3,
      number: "03",
      title: "Design & Planning",
      description:
        "Our team develops a thoughtful swimming pool concept that fits your space and complements the surroundings.",
    },
    {
      id: 4,
      number: "04",
      title: "Features & Finishes",
      description:
        "We plan suitable finishes, decking, lighting, landscaping, water features, and other design elements.",
    },
    {
      id: 5,
      number: "05",
      title: "Final Design",
      description:
        "The final pool design is prepared with attention to aesthetics, functionality, space, and your requirements.",
    },
  ];

  return (
    <>
      {/* =========================
          HERO
      ========================= */}

      <section
        className="swimming-pool-hero"
        style={{
          backgroundImage: `url(${swimmingPoolImage})`,
        }}
      >
        <div className="swimming-pool-overlay">
          <div className="container text-center">
            <h1>Swimming Pool Design in Dubai</h1>

            <p>
              Creative and professional swimming pool design solutions for
              beautiful, relaxing, and functional outdoor spaces.
            </p>

            <Link to="/contact" className="swimming-pool-hero-btn">
              GET A QUOTE
            </Link>
          </div>
        </div>
      </section>

      {/* =========================
          INTRODUCTION
      ========================= */}

      <section className="swimming-pool-intro-section">
        <div className="container">
          <div className="swimming-pool-intro">
            <span>SWIMMING POOL DESIGN</span>

            <h2>
              Beautiful Swimming Pool Designs Created for Your Outdoor Space
            </h2>

            <p>
              We create thoughtfully planned swimming pool designs that combine
              beauty, comfort, functionality, and outdoor living. Our pool
              design solutions are tailored to the available space, surrounding
              landscape, property style, and individual requirements.
            </p>

            <p>
              From modern villa pools and luxury swimming pools to garden
              swimming pools and customized outdoor pool concepts, we focus on
              creating designs that enhance the overall appearance and
              experience of your outdoor space.
            </p>
          </div>
        </div>
      </section>

      {/* =========================
          SWIMMING POOL SERVICES
      ========================= */}

      <section className="swimming-pool-services-section">
        <div className="container">
          <div className="swimming-pool-section-heading text-center">
            <span>OUR SERVICES</span>

            <h2>Swimming Pool Design Solutions</h2>

            <p>
              Explore our swimming pool design solutions created for homes,
              villas, gardens, and premium outdoor spaces.
            </p>
          </div>

          <div className="row swimming-pool-services-row">
            {poolServices.map((service) => (
              <div
                className="col-lg-4 col-md-6 col-12"
                key={service.id}
              >
                <div className="swimming-pool-service-card">
                  <div className="swimming-pool-icon">
                    <i className={service.icon}></i>
                  </div>

                  <h3>{service.title}</h3>

                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================
          DESIGN FEATURES
      ========================= */}

      <section className="swimming-pool-features-section">
        <div className="container">
          <div className="swimming-pool-section-heading text-center">
            <span>DESIGN FEATURES</span>

            <h2>Complete Pool Design Planning</h2>

            <p>
              Every swimming pool concept can be planned with carefully
              selected design elements to create a complete outdoor
              environment.
            </p>
          </div>

          <div className="row swimming-pool-features-row">
            {poolFeatures.map((feature) => (
              <div
                className="col-lg-4 col-md-6 col-12"
                key={feature.id}
              >
                <div className="swimming-pool-feature-card">
                  <div className="swimming-pool-feature-icon">
                    <i className={feature.icon}></i>
                  </div>

                  <div>
                    <h3>{feature.title}</h3>

                    <p>{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================
          DESIGN PROCESS
      ========================= */}

      <section className="swimming-pool-process-section">
        <div className="container">
          <div className="swimming-pool-section-heading text-center">
            <span>OUR PROCESS</span>

            <h2>Our Swimming Pool Design Process</h2>

            <p>
              We follow a structured approach to develop swimming pool designs
              that match the property, outdoor space, and project requirements.
            </p>
          </div>

          <div className="row swimming-pool-process-row">
            {designProcess.map((step) => (
              <div
                className="col-lg-4 col-md-6 col-12"
                key={step.id}
              >
                <div className="swimming-pool-process-card">
                  <div className="swimming-pool-process-number">
                    {step.number}
                  </div>

                  <h3>{step.title}</h3>

                  <p>{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================
          PROJECTS / PHOTOS
      ========================= */}

      <section className="swimming-pool-projects-section">
        <div className="container">
          <div className="swimming-pool-section-heading text-center">
            <span>OUR PROJECTS</span>

            <h2>Swimming Pool Design Projects</h2>

            <p>
              Explore examples of swimming pool concepts and outdoor designs
              created for different spaces and requirements.
            </p>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-6 col-12">
              <div className="swimming-pool-project-card">
                <div className="swimming-pool-project-placeholder">
                  <img src={ModernPoolDesign} alt="Villa Swimming Pool" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  {/* <span>Project Image</span> */}
                </div>

                <div className="swimming-pool-project-info">
                  <h3>Modern Pool Design</h3>
                  <p>Dubai, UAE</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12">
              <div className="swimming-pool-project-card">
                <div className="swimming-pool-project-placeholder">
                  {/* <i className="fas fa-swimming-pool"></i> */}
                  <img src={VillaSwimmingPool} alt="Villa Swimming Pool" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  {/* <span>Project Image</span> */}
                </div>

                <div className="swimming-pool-project-info">
                  <h3>Villa Swimming Pool</h3>
                  <p>Dubai, UAE</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12">
              <div className="swimming-pool-project-card">
                <div className="swimming-pool-project-placeholder">
                  <img src={LuxuryPoolDesign} alt="Luxury Pool Design" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  {/* <span>Project Image</span> */}
                </div>

                <div className="swimming-pool-project-info">
                  <h3>Luxury Pool Design</h3>
                  <p>Dubai, UAE</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================
          CTA
      ========================= */}

      <section className="swimming-pool-cta-section">
        <div className="container">
          <div className="swimming-pool-cta">
            <h2>Ready to Design Your Dream Swimming Pool?</h2>

            <p>
              Talk to our team about your swimming pool design and create a
              beautiful outdoor space tailored to your property.
            </p>

            <Link to="/contact" className="swimming-pool-cta-btn">
              REQUEST A QUOTE
            </Link>
          </div>
        </div>
      </section>

      {/* =========================
          CSS
      ========================= */}

      <style>
        {`

        /* =========================
           HERO
        ========================= */

        .swimming-pool-hero {
          min-height: 560px;
          background-size: cover;
          background-position: center;
          position: relative;
          display: flex;
          align-items: center;
        }

        .swimming-pool-overlay {
          width: 100%;
          padding: 110px 20px;
          background: rgba(0, 0, 0, 0.48);
        }

        .swimming-pool-hero h1 {
          max-width: 950px;
          margin: 0 auto 18px;
          color: #fff;
          font-size: 55px;
          line-height: 1.15;
          font-weight: 700;
        }

        .swimming-pool-hero p {
          max-width: 750px;
          margin: 0 auto 30px;
          color: #fff;
          font-size: 18px;
          line-height: 1.7;
        }

        .swimming-pool-hero-btn {
          display: inline-block;
          padding: 14px 28px;
          color: #fff;
          background: #4c8b3c;
          border-radius: 4px;
          font-size: 13px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .swimming-pool-hero-btn:hover {
          color: #fff;
          background: #35652b;
          text-decoration: none;
          transform: translateY(-2px);
        }


        /* =========================
           COMMON HEADING
        ========================= */

        .swimming-pool-section-heading {
          max-width: 850px;
          margin: 0 auto 55px;
        }

        .swimming-pool-section-heading span {
          display: inline-block;
          margin-bottom: 10px;
          color: #4c8b3c;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 3px;
        }

        .swimming-pool-section-heading h2 {
          margin: 0 0 18px;
          color: #222;
          font-size: 40px;
          line-height: 1.25;
          font-weight: 700;
        }

        .swimming-pool-section-heading p {
          margin: 0;
          color: #666;
          font-size: 16px;
          line-height: 1.8;
        }


        /* =========================
           INTRO
        ========================= */

        .swimming-pool-intro-section {
          padding: 90px 20px;
          background: #fff;
        }

        .swimming-pool-intro {
          max-width: 900px;
          margin: auto;
          text-align: center;
        }

        .swimming-pool-intro span {
          display: inline-block;
          margin-bottom: 12px;
          color: #4c8b3c;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 3px;
        }

        .swimming-pool-intro h2 {
          margin: 0 0 22px;
          color: #222;
          font-size: 40px;
          line-height: 1.25;
          font-weight: 700;
        }

        .swimming-pool-intro p {
          margin: 0 0 15px;
          color: #666;
          font-size: 16px;
          line-height: 1.85;
        }


        /* =========================
           SERVICES
        ========================= */

        .swimming-pool-services-section {
          padding: 90px 20px;
          background: #f8faf7;
        }

        .swimming-pool-services-row {
          row-gap: 30px;
        }

        .swimming-pool-service-card {
          height: 100%;
          padding: 38px 28px;
          text-align: center;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
          transition: all 0.35s ease;
        }

        .swimming-pool-service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
        }

        .swimming-pool-icon {
          width: 70px;
          height: 70px;
          margin: 0 auto 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: #edf6ea;
        }

        .swimming-pool-icon i {
          color: #4c8b3c;
          font-size: 30px;
        }

        .swimming-pool-service-card h3 {
          margin: 0 0 14px;
          color: #222;
          font-size: 21px;
          font-weight: 700;
        }

        .swimming-pool-service-card p {
          margin: 0;
          color: #666;
          font-size: 14px;
          line-height: 1.75;
        }


        /* =========================
           FEATURES
        ========================= */

        .swimming-pool-features-section {
          padding: 90px 20px;
          background: #fff;
        }

        .swimming-pool-features-row {
          row-gap: 30px;
        }

        .swimming-pool-feature-card {
          height: 100%;
          display: flex;
          gap: 20px;
          padding: 30px 25px;
          background: #f7faf6;
          border-radius: 10px;
          transition: all 0.3s ease;
        }

        .swimming-pool-feature-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
        }

        .swimming-pool-feature-icon {
          min-width: 55px;
          height: 55px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #4c8b3c;
          border-radius: 50%;
        }

        .swimming-pool-feature-icon i {
          color: #fff;
          font-size: 22px;
        }

        .swimming-pool-feature-card h3 {
          margin: 0 0 10px;
          color: #222;
          font-size: 19px;
          font-weight: 700;
        }

        .swimming-pool-feature-card p {
          margin: 0;
          color: #666;
          font-size: 14px;
          line-height: 1.7;
        }


        /* =========================
           PROCESS
        ========================= */

        .swimming-pool-process-section {
          padding: 90px 20px;
          background: #f8faf7;
        }

        .swimming-pool-process-row {
          row-gap: 30px;
        }

        .swimming-pool-process-card {
          height: 100%;
          padding: 35px 28px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 7px 25px rgba(0, 0, 0, 0.06);
          transition: all 0.3s ease;
        }

        .swimming-pool-process-card:hover {
          transform: translateY(-7px);
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
        }

        .swimming-pool-process-number {
          margin-bottom: 20px;
          color: #4c8b3c;
          font-size: 36px;
          line-height: 1;
          font-weight: 800;
        }

        .swimming-pool-process-card h3 {
          margin: 0 0 12px;
          color: #222;
          font-size: 21px;
          font-weight: 700;
        }

        .swimming-pool-process-card p {
          margin: 0;
          color: #666;
          font-size: 14px;
          line-height: 1.75;
        }


        /* =========================
           PROJECTS
        ========================= */

        .swimming-pool-projects-section {
          padding: 90px 20px;
          background: #fff;
        }

        .swimming-pool-projects-section .row {
          row-gap: 30px;
        }

        .swimming-pool-project-card {
          height: 100%;
          overflow: hidden;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.07);
          transition: all 0.35s ease;
        }

        .swimming-pool-project-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 18px 40px rgba(0, 0, 0, 0.13);
        }

        .swimming-pool-project-placeholder {
          width: 100%;
          height: 270px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #edf3eb;
          color: #4c8b3c;
        }

        .swimming-pool-project-placeholder i {
          margin-bottom: 12px;
          font-size: 50px;
        }

        .swimming-pool-project-placeholder span {
          color: #777;
          font-size: 13px;
        }

        .swimming-pool-project-info {
          padding: 23px;
        }

        .swimming-pool-project-info h3 {
          margin: 0 0 8px;
          color: #222;
          font-size: 20px;
          font-weight: 700;
        }

        .swimming-pool-project-info p {
          margin: 0;
          color: #777;
          font-size: 14px;
        }


        /* =========================
           CTA
        ========================= */

        .swimming-pool-cta-section {
          padding: 0 20px 90px;
          background: #fff;
        }

        .swimming-pool-cta {
          padding: 65px 30px;
          text-align: center;
          background: #4c8b3c;
          border-radius: 12px;
        }

        .swimming-pool-cta h2 {
          margin: 0 0 15px;
          color: #fff;
          font-size: 34px;
          font-weight: 700;
        }

        .swimming-pool-cta p {
          max-width: 700px;
          margin: 0 auto 25px;
          color: #fff;
          font-size: 16px;
          line-height: 1.7;
        }

        .swimming-pool-cta-btn {
          display: inline-block;
          padding: 13px 28px;
          color: #4c8b3c;
          background: #fff;
          border-radius: 4px;
          font-size: 13px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .swimming-pool-cta-btn:hover {
          color: #4c8b3c;
          background: #f2f2f2;
          text-decoration: none;
          transform: translateY(-2px);
        }


        /* =========================
           RESPONSIVE
        ========================= */

        @media (max-width: 767px) {

          .swimming-pool-hero {
            min-height: 440px;
          }

          .swimming-pool-overlay {
            padding: 80px 15px;
          }

          .swimming-pool-hero h1 {
            font-size: 36px;
          }

          .swimming-pool-hero p {
            font-size: 15px;
          }

          .swimming-pool-intro-section,
          .swimming-pool-services-section,
          .swimming-pool-features-section,
          .swimming-pool-process-section,
          .swimming-pool-projects-section {
            padding: 60px 15px;
          }

          .swimming-pool-section-heading h2,
          .swimming-pool-intro h2 {
            font-size: 30px;
          }

          .swimming-pool-feature-card {
            padding: 25px 20px;
          }

          .swimming-pool-project-placeholder {
            height: 240px;
          }

          .swimming-pool-cta-section {
            padding: 0 15px 60px;
          }

          .swimming-pool-cta {
            padding: 45px 20px;
          }

          .swimming-pool-cta h2 {
            font-size: 28px;
          }

        }

        `}
      </style>
    </>
  );
};

export default SwimmingPoolDesign;